import createCachedSelector from 're-reselect';
import {forEach as _forEach} from 'lodash';

const getSubstate = state => state.specific.interferometryData;
const getAllByTypeByTrackKeyFeatures = state =>
	state.specific.interferometryData.byTypeByTrackKeyFeatures;
const getAllByTypeByFeatureKey = state =>
	state.specific.interferometryData.byTypeByFeatureKey;

const getFeaturesByTypeAndTrackKey = createCachedSelector(
	[
		getAllByTypeByTrackKeyFeatures,
		(state, type) => type,
		(state, type, trackKey) => trackKey,
	],
	(data, type, trackKey) => {
		return data?.[type]?.[trackKey];
	}
)((state, type, trackKey) => `${type}_${trackKey}`);

const getAllFeaturesByTypeAndTrackKeys = createCachedSelector(
	[
		getAllByTypeByTrackKeyFeatures,
		(state, type) => type,
		(state, type, trackKeys) => trackKeys,
	],
	(data, type, trackKeys) => {
		let allFeatures = [];
		_forEach(trackKeys, trackKey => {
			const features = data?.[type]?.[trackKey];
			if (features?.length) {
				allFeatures = [...allFeatures, ...features];
			}
		});

		return allFeatures?.length ? allFeatures : null;
	}
)((state, type, trackKeys) => `${type}_${JSON.stringify(trackKeys)}`);

const getFeatureByTypeAndFeatureKey = createCachedSelector(
	[
		getAllByTypeByFeatureKey,
		(state, type) => type,
		(state, type, featureKey) => featureKey,
	],
	(data, type, featureKey) => {
		return data?.[type]?.[featureKey];
	}
)((state, type, featureKey) => `${type}_${featureKey}`);

export default {
	getSubstate,

	getAllByTypeByFeatureKey,
	getAllFeaturesByTypeAndTrackKeys,
	getFeaturesByTypeAndTrackKey,
	getFeatureByTypeAndFeatureKey,
};
